import { Component } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'lowy-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent {
  visible: boolean;
  isOpen: boolean;
  message: string;

  private closingTimeout;

  constructor (private toastService: ToastService) {
    this.toastService.toast$.subscribe(message => {

      if (this.isOpen || this.visible) {
        const waitForOpen = setInterval(() => {
          if (!this.isOpen && !this.visible) {
            this.setToast(message);
            clearInterval(waitForOpen);
          }
        }, 100);
      }
      else {
        this.setToast(message);
      }

    });
  }

  private setToast(message) {
    this.message = message;
    this.open();

    this.closingTimeout = setTimeout(() => {
      this.close();
    }, 3500);
  }

  private open() {
    this.visible = true;
    setTimeout(() => {
      this.isOpen = true;
    });
  }

  private close() {
    if (this.isOpen) {
      this.isOpen = false;
      setTimeout(() => {
        this.visible = false;
      }, 1000);
    }
  }

  public closeFast() {
    this.isOpen = false;
    this.visible = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/toast/toast.component.ts